import { extendTailwindMerge } from 'tailwind-merge'
import { clsx } from 'clsx'
import type { ClassValue } from 'clsx'

export function cx(...classes: ClassValue[]) {
  return classes.filter(Boolean).join(' ')
}

//this will fix issues where the size of the text is overriding the color
//https://github.com/dcastil/tailwind-merge/blob/v2.2.1/docs/configuration.md
const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        'text-xxs',
        'text-xs',
        'text-sm',
        'text-base',
        'text-lg',
        'text-xl',
        'text-10',
        'text-12',
        'text-13',
        'text-14',
        'text-16',
        'text-20',
        'text-24',
        'text-30',
        'typography-10',
        'typography-10-capitals',
        'typography-11',
        'typography-12',
        'typography-12-semibold',
        'typography-13',
        'typography-14',
        'typography-15',
        'typography-16',
        'typography-16-bold',
        'typography-20',
        'typography-24-semibold',
      ],
      rounded: [
        'rounded-studio-geometry-semantic-radius-none',
        'rounded-studio-geometry-semantic-radius-2xs',
        'rounded-studio-geometry-semantic-radius-xs',
        'rounded-studio-geometry-semantic-radius-sm',
        'rounded-studio-geometry-semantic-radius-md',
        'rounded-studio-geometry-semantic-radius-lg',
        'rounded-studio-geometry-semantic-radius-xl',
        'rounded-studio-geometry-semantic-radius-2xl',
        'rounded-studio-geometry-semantic-radius-full',
      ],
    },
  },
})

export function tw(...classes: ClassValue[]) {
  return customTwMerge(clsx(classes))
}
